"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  TouchIdLock: ['touch-id-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,1.753A7.5,7.5,0,0,0,.75,8.25', 'M15.75,8.25a7.478,7.478,0,0,0-.624-3', 'M8.25,23.25a7.563,7.563,0,0,0,1.5-.15', 'M.75,12.75v3a7.5,7.5,0,0,0,4.5,6.876', 'M12.75,12.75V8.25A4.5,4.5,0,0,0,6,4.352', 'M3.75,8.25v7.5a4.5,4.5,0,0,0,6,4.244', 'M6.75,15.75a1.5,1.5,0,0,0,3,0V8.25a1.5,1.5,0,0,0-3,0v3', 'M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z', 'M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z', 'M18.75,19.154a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  TouchId: ['touch-id', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3 14.25L3 23.25', 'M16.478,2.144A8.311,8.311,0,0,0,11.888.75h0C7.37.75,3.613,4.453,3.072,9.2', 'M21,23.25V10.375A10.187,10.187,0,0,0,20.023,6', 'M18,15.75v-4.5c0-3.713-2.7-6.75-6-6.75h0c-3.3,0-6,3.037-6,6.75v12', 'M18 23.25L18 18.75', 'M9 17.25L9 23.25', 'M15,23.25V12c0-2.063-1.35-3.75-3-3.75h0c-1.65,0-3,1.687-3,3.75v2.25', 'M12 20.25L12 23.25', 'M12 11.25L12 17.25']],
  TouchFinger: ['touch-finger', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,23.25,6.236,20.14a1.557,1.557,0,0,1,2.328-2.069L10.5,20.25v-9a1.5,1.5,0,0,1,3,0V18H15a4.5,4.5,0,0,1,4.5,4.5v.751', 'M16.5,14.216a7.5,7.5,0,1,0-9,0', 'M16.5,14.216a7.5,7.5,0,1,0-9,0']],
  TouchIdDenied1: ['touch-id-denied-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.376 18L14.626 23.25', 'M9.376 23.25L14.626 18', 'M6,23.25H2.251a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5H6', 'M18,23.25h3.75a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H18', 'M16.5,14.25v-6A4.477,4.477,0,0,0,15.9,6', 'M7.501 8.25L7.501 14.25', 'M13.472,4a4.507,4.507,0,0,0-5.2,1.738', 'M10.5,9V8.25a1.5,1.5,0,0,1,3,0v6', 'M10.501 12L10.501 14.25']],
  TouchIdDesktop: ['touch-id-desktop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.001 23.25L9.001 23.25 9.751 18.75 14.251 18.75 15.001 23.25z', 'M6.751 23.25L17.251 23.25', 'M0.751 0.750 L23.251 0.750 L23.251 18.750 L0.751 18.750 Z', 'M0.751 15.75L23.251 15.75', 'M16.5,12.75V8.25A4.477,4.477,0,0,0,15.9,6', 'M7.501 8.25L7.501 12.75', 'M13.472,4a4.507,4.507,0,0,0-5.2,1.738', 'M10.5,9V8.25a1.5,1.5,0,0,1,3,0v4.5', 'M10.501 12L10.501 12.75']],
  TouchIdTarget: ['touch-id-target', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,22.246A7.5,7.5,0,0,1,.75,15.75', 'M15.75,15.75a7.481,7.481,0,0,1-.624,3', 'M8.25.75A7.489,7.489,0,0,1,9.75.9', 'M.75,11.25v-3a7.5,7.5,0,0,1,4.5-6.876', 'M12.75,13.5v2.25A4.5,4.5,0,0,1,6,19.648', 'M3.75,15.75V8.25a4.5,4.5,0,0,1,6-4.244', 'M9.75,9.75v6a1.5,1.5,0,0,1-3,0v-3', 'M6.75,8.25a1.5,1.5,0,0,1,1.5-1.5', 'M12.750 6.750 A4.500 4.500 0 1 0 21.750 6.750 A4.500 4.500 0 1 0 12.750 6.750 Z', 'M17.25 0.75L17.25 3.75', 'M17.25 9.75L17.25 12.75', 'M20.25 6.75L23.25 6.75', 'M11.25 6.75L14.25 6.75', 'M17.25,6.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  TouchId5: ['touch-id-5', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,23.25H2.251a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5H6', 'M18,23.25h3.75a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H18', 'M18,13.5V12c0-3.713-2.7-6.75-6-6.75h0C8.7,5.25,6,8.287,6,12v6', 'M18.001 18L18.001 16.5', 'M9.001 16.5L9.001 18', 'M15,18V12.75C15,10.687,13.651,9,12,9h0c-1.65,0-3,1.687-3,3.75v.75', 'M12.001 17.25L12.001 18', 'M12.001 12L12.001 14.25']],
  TouchIdUser: ['touch-id-user', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,1.753A7.5,7.5,0,0,0,.75,8.25', 'M15.75,8.25a7.478,7.478,0,0,0-.624-3', 'M8.25,23.25a7.563,7.563,0,0,0,1.5-.15', 'M.75,12.75v3a7.5,7.5,0,0,0,4.5,6.876', 'M12.75,10.5V8.25A4.5,4.5,0,0,0,6,4.352', 'M3.75,8.25v7.5a4.5,4.5,0,0,0,6,4.244', 'M6.75,15.75a1.5,1.5,0,0,0,3,0V8.25a1.5,1.5,0,0,0-3,0v3', 'M15.375 13.125 A2.625 2.625 0 1 0 20.625 13.125 A2.625 2.625 0 1 0 15.375 13.125 Z', 'M18,16.5a5.25,5.25,0,0,0-5.25,5.25v1.5h10.5v-1.5A5.249,5.249,0,0,0,18,16.5Z']],
  TouchIdApproved1: ['touch-id-approved-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,23.25H2.251a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5H6', 'M18,23.25h3.75a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H18', 'M16.501 18L11.251 23.25 9.001 20.25', 'M16.5,14.25v-6A4.477,4.477,0,0,0,15.9,6', 'M7.501 8.25L7.501 14.25', 'M13.472,4a4.507,4.507,0,0,0-5.2,1.738', 'M10.5,9V8.25a1.5,1.5,0,0,1,3,0v6', 'M10.501 12L10.501 14.25']],
  TouchIdSearch: ['touch-id-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,1.753A7.5,7.5,0,0,0,.75,8.25', 'M15.75,8.25a7.478,7.478,0,0,0-.624-3', 'M8.25,23.25a7.563,7.563,0,0,0,1.5-.15', 'M.75,12.75v3a7.5,7.5,0,0,0,4.5,6.876', 'M12.75,8.25A4.5,4.5,0,0,0,6,4.352', 'M3.75,8.25v7.5a4.5,4.5,0,0,0,4.5,4.5', 'M9.75,9.75V8.25a1.5,1.5,0,0,0-3,0v3', 'M6.75,15.75a1.5,1.5,0,0,0,1.5,1.5', 'M10.500 15.750 A5.250 5.250 0 1 0 21.000 15.750 A5.250 5.250 0 1 0 10.500 15.750 Z', 'M23.25 23.25L19.462 19.462']],
  TouchIdSmartphone1: ['touch-id-smartphone-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15,15v5.25a3,3,0,0,1-3,3H4.5a3,3,0,0,1-3-3V3.75a3,3,0,0,1,3-3H12', 'M1.501 18.75L15.001 18.75', 'M22.5,12V6.75a4.477,4.477,0,0,0-.6-2.25', 'M13.501 6.75L13.501 12', 'M19.472,2.5a4.507,4.507,0,0,0-5.2,1.738', 'M16.5,7.5V6.75a1.5,1.5,0,0,1,3,0V12', 'M16.501 10.5L16.501 12']],
  TouchId3: ['touch-id-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.008,13.5V12c0-3.713-2.7-6.75-6-6.75h0c-3.3,0-6,3.037-6,6.75v6.75', 'M18.008 18.75L18.008 16.5', 'M9.008 16.5L9.008 18.75', 'M15.008,18.75v-6c0-2.063-1.35-3.75-3-3.75h0c-1.65,0-3,1.687-3,3.75v.75', 'M12.008 17.25L12.008 18.75', 'M12.008 12L12.008 14.25', 'M0.758 0.750 L23.258 0.750 L23.258 23.250 L0.758 23.250 Z']],
  TouchIdLock1: ['touch-id-lock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.251 6.750 L21.751 6.750 L21.751 23.250 L2.251 23.250 Z', 'M6.751,6.75V6a5.25,5.25,0,0,1,10.5,0v.75', 'M16.5,19.5V15a4.477,4.477,0,0,0-.6-2.25', 'M7.501 15L7.501 19.5', 'M13.472,10.746a4.507,4.507,0,0,0-5.2,1.738', 'M10.5,15.75V15a1.5,1.5,0,0,1,3,0v4.5', 'M10.501 18.75L10.501 19.5']],
  TouchId4: ['touch-id-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,12.75v-1.5c0-3.713-2.7-6.75-6-6.75h0c-3.3,0-6,3.037-6,6.75v6', 'M18.001 17.25L18.001 15.75', 'M9.001 15.75L9.001 17.25', 'M15,17.25V12c0-2.063-1.35-3.75-3-3.75h0c-1.65,0-3,1.687-3,3.75v.75', 'M12.001 16.5L12.001 17.25', 'M12.001 11.25L12.001 13.5', 'M0.751 12.000 A11.250 11.250 0 1 0 23.251 12.000 A11.250 11.250 0 1 0 0.751 12.000 Z']],
  TouchIdApproved: ['touch-id-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,1.753A7.5,7.5,0,0,0,.75,8.25', 'M15.75,8.25a7.478,7.478,0,0,0-.624-3', 'M8.25,23.25a7.563,7.563,0,0,0,1.5-.15', 'M.75,12.75v3a7.5,7.5,0,0,0,4.5,6.876', 'M12.75,9.75V8.25A4.5,4.5,0,0,0,6,4.352', 'M3.75,8.25v7.5a4.5,4.5,0,0,0,4.5,4.5', 'M9.75,12V8.25a1.5,1.5,0,0,0-3,0v3', 'M6.75,15.75a1.5,1.5,0,0,0,1.5,1.5', 'M11.247 17.250 A6.000 6.000 0 1 0 23.247 17.250 A6.000 6.000 0 1 0 11.247 17.250 Z', 'M19.921,15.505l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5']],
  TouchId1: ['touch-id-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.749,9a8.25,8.25,0,0,1,13.5-6.364', 'M19.687,6a8.23,8.23,0,0,1,.562,3v6A8.25,8.25,0,0,1,12,23.25a8.336,8.336,0,0,1-1.5-.136', 'M6.751,21.365a8.234,8.234,0,0,1-3-6.365V12.75', 'M15.749,15V9a3.75,3.75,0,0,0-6-3', 'M8.249,9v6A3.753,3.753,0,0,0,13.5,18.438', 'M11.999 9.75L11.999 14.25']],
  TouchId2: ['touch-id-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75v6a1.5,1.5,0,0,1-1.5,1.5h-6', 'M15.75.75h6a1.5,1.5,0,0,1,1.5,1.5v6', 'M.75,8.25v-6A1.5,1.5,0,0,1,2.25.75h6', 'M8.25,23.25h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M18,13.875v-1.5c0-3.713-2.7-6.75-6-6.75h0c-3.3,0-6,3.037-6,6.75v6', 'M18 18.375L18 16.875', 'M9 16.875L9 18.375', 'M15,18.375v-5.25c0-2.063-1.35-3.75-3-3.75h0c-1.65,0-3,1.687-3,3.75v.75', 'M12 17.625L12 18.375', 'M12 12.375L12 14.625']],
  TouchIdDenied: ['touch-id-denied', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,1.753A7.5,7.5,0,0,0,.75,8.25', 'M15.75,8.25a7.478,7.478,0,0,0-.624-3', 'M8.25,23.25a7.563,7.563,0,0,0,1.5-.15', 'M.75,12.75v3a7.5,7.5,0,0,0,4.5,6.876', 'M12.75,9.75V8.25A4.5,4.5,0,0,0,6,4.352', 'M3.75,8.25v7.5a4.5,4.5,0,0,0,4.5,4.5', 'M9.75,12V8.25a1.5,1.5,0,0,0-3,0v3', 'M6.75,15.75a1.5,1.5,0,0,0,1.5,1.5', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.5 14.999L15 19.499', 'M15 14.999L19.5 19.499']]
};
exports["default"] = _default;